module.exports = __webpack_public_path__ + "img/材料力学6_8_3.8079dba1.jpg";